import { useModalContextStrict } from './ModalContext';

export const useInsideModalDetector = () => {
  const modalContext = useModalContextStrict();

  return { insideModal: modalContext !== undefined };
};
